// Estd

// Variables/Plugins
import $ from 'jquery';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import Splide from '@splidejs/splide';

// Variables 
const $d = $(document),
  $w = $(window);


const swup = new Swup({
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: true,
      scrollFriction: 0.3,
      scrollAcceleration: 0.04,
    })
  ]
});

// Events
swup.on('contentReplaced', init);

$d.on('click', '.cookie_btn', setCookie);
$d.on('mouseenter', '.nav__dropdown-trig', dropDownShow);
$d.on('mouseleave', 'header', dropDownClose);
$d.on('mouseenter', '.team__item a', flipOn);
$d.on('mouseleave', '.team__item a', flipOff);
$d.on('click', '.accordion__button', accordionToggle);
// $d.on('click', '.filter-button.on', catOff);
$d.on('click', '.filter-button', catOn);
$d.on('click', '.team__grid--big a', modalShow);
$d.on('click', '.modal__bg, .modal__close', modalClose);
$d.on('input', '.slider__control input', sliderMove);
$('.slider__track').on('scroll', inputMove);
$('.slider__track').on('touchmove', inputMove);

$d.on('scroll', headerCheck);
$d.on('click', '.monav__button', monavToggle);
$d.on('click', '.monav__dropdown-trig', monavDropDownToggle);
$d.on('click', '.circle-button__dot', videoToggle);

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  checkCookie();
  init();
});

// Functions 
function l(m) {
  console.log(m);
}

function init() {
  // highlightActive();
  // lazyImages();

  let header_color = $('main').data('header');

  if (header_color == 'header--white') {
    headerWhite();
  } else {
    headerBlack();
  }

  var elms = document.getElementsByClassName('splide');

  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      // type : 'fade',
      autoplay: true,
      arrows: false,
      rewind: true,
      interval: 3000
    }).mount();
  }

  checkSplash()
}

function checkSplash() {
  if (!localStorage.getItem("first-run")) {
    hideSplash();
    localStorage.setItem("first-run", true);
    l('first ran')

  } else {
    $('.splash').remove()
    l('already ran')

  }
}

function hideSplash() {
  $('.splash video').on('ended', function () {
    $('.splash').addClass('bye');

    window.setTimeout(function () {
      $('.splash').remove()
    }, 200);
  });


}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  $('.cookie').addClass('hidden');
}

function checkCookie() {
  l('check cookie');
  if (document.cookie.indexOf('cookie-note=1') !== -1) {
    $('.cookie').addClass('hidden');
  } else {
    $('.cookie').removeClass('hidden');
  }

  if (document.cookie.indexOf('cookie-form=1') !== -1) {
    $('.overlay').addClass('hidden');
  } else {
    $('.overlay').removeClass('hidden');
  }

}


function dropDownShow() {
  $('ul.active').removeClass('active');
  $('.nav__dropdown-trig').removeClass('active');

  $(this).next('ul').addClass('active');
  $(this).addClass('active');

}


function dropDownClose() {

  $('.nav__dropdown-trig').removeClass('active');
  $('ul.active').removeClass('active');

}

function flipOn() {

  $(this).removeClass('flip-off');
  $(this).addClass('flip-on');

}

function flipOff() {

  $(this).removeClass('flip-on');
  $(this).addClass('flip-off');


}


function accordionToggle() {
  $(this)

  let accordion = $(this).parent('.accordion');

  accordion.toggleClass('open')
}


function catOn() {
  $('.button--cat').removeClass('on');
  $(this).addClass('on');


  let cat = $(this).data('cat')
  $('.filter-grid').removeClass('show-public-affairs-regulatory');
  $('.filter-grid').removeClass('show-campaigning');
  $('.filter-grid').removeClass('show-financial-communications');
  $('.filter-grid').removeClass('show-all');
  $('.filter-grid').addClass('show-' + cat);


  console.log(cat)

  $('.team__item').addClass('visible');

}


// function catOff() {
//   $(this).removeClass('on');
//   $(this).addClass('off');

//   let cat = $(this).data('cat')

//   $('.filter-grid').removeClass('show-' + cat)

// }

function modalShow() {
  let slug = $(this).data('slug');
  $('body').css('overflow', 'hidden');


  $('.' + slug).addClass('on');
}

function modalClose() {
  $('body').css('overflow', 'visible');

  $('.modal').removeClass('on');

}

function sliderMove() {

  let move = $(this).val();
  let panel = $(this).parents('.slider').find('.slider__track');

  var total = panel[0].scrollWidth - panel[0].offsetWidth;

  var percentage = total * (move / 100);

  panel[0].scrollLeft = percentage;
}


function inputMove(e) {
  let horizontal = e.currentTarget.scrollLeft;

  var total = $(this)[0].scrollWidth - $(this)[0].offsetWidth;
  var percentage = (horizontal / total) * 100;

  percentage = Math.floor(percentage);

  l(percentage);

  let control = $(this).parents('.slider').find('.slider__control input');

  control.val(percentage);
}

function headerBGWhite() {
  $('header').addClass('header--bg-white');
}

function headerBGTransparent() {
  $('header').removeClass('header--bg-white');
}



function headerWhite() {
  $('header').addClass('header--white');
}

function headerBlack() {
  $('header').removeClass('header--white');
}

function headerCheck() {

  let header_color = $('main').data('header');

  // if(header_color == 'header--white') {

  //   let banner_bottom = $('.banner').height();


  //   if(banner_bottom > $(document).scrollTop()){
  //     headerWhite()
  //   } else {
  //     headerBlack();
  //   }

  // } 

  if ($(document).scrollTop() > 20) {
    headerBGWhite()
  } else {
    headerBGTransparent()
  }
}


function monavToggle() {
  $('body').toggleClass('monav-open');
}

function monavDropDownToggle() {

  $(this).next('ul').toggleClass('active');
  $(this).toggleClass('active');


}

function videoToggle() {

  let container = $(this).parents('.circle-button');
  let video = container.find('video')[0]
  let cover = container.find('.circle-button__cover');
  let dot = container.find('.circle-button__dot');
  let text = container.find('.circle-button__text');

  dot.addClass('bye');
  text.hide();
  cover.fadeOut();
  video.play();
}



$('input.button').on('click', function (e) {
  // validation code here
  // e.preventDefault();
  l('form clicked');
});
